// extracted by mini-css-extract-plugin
module.exports = {"title":"components-QuestionTemplateNext-Question-Question__title--1_4D-"};